/*
---
description: Additional methods for the Array class

license: MIT-style

authors:
- Alexander Herrmann

requires:
  core/1.4.3: [Array]

provides:
- Array.intersect
- Array.differentiate
- Array.getRange
- Array.reverse()
...
*/
Array.implement({intersect:function(a){var b=this.slice();this.each(function(c){if(a.indexOf(c)<0){b.splice(b.indexOf(c),1)}},this);return b},differentiate:function(a){var c=this.slice();var b=a.slice();a.each(function(d){if(c.indexOf(d)>-1){c.splice(c.indexOf(d),1);b.splice(b.indexOf(d),1)}},this);return c.combine(b)},getRange:function(f,e){var c=[];var a=0;var d=this.length;if(undefined!=e){var d=f+e>this.length?this.length:f+e}if(f>=0){for(var b=f;b<d;b++){c[a++]=this[b]}}return c},reverse:function(){var b=[];for(var a=this.length-1;a>=0;a--){b.push(this[a])}return b}});